import { render, staticRenderFns } from "./LatestComments.vue?vue&type=template&id=2f4fbb6d&"
import script from "./LatestComments.vue?vue&type=script&lang=js&"
export * from "./LatestComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports